import styled from "@emotion/styled";
import { Box, Card, Tabs, Theme } from "@mui/material";

export const PagesBox = styled(Box)<{ theme: Theme }>((props) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: props.theme.spacing(1),
  margin: props.theme.spacing(1),
  '& .MuiBox-root': {
    borderRadius: "8px",
    padding: props.theme.spacing(1)
  }
}));

export const FirstBox = styled(Box)<{ theme: Theme }>((props) => ({
  gridRow: "1 / span 2",
  backgroundColor: props.theme.palette.warning.light + 'b0'
}));

export const CardContainer = styled(Card)<{theme: Theme}>((props) => ({
  overflow: "unset",
  margin: props.theme.spacing(1.5),
  marginBottom: props.theme.spacing(9)
}));

export const OfferBox = styled(Box)<{ theme: Theme }>((props) => ({
  overflow: "auto",
  whiteSpace: "nowrap",
  paddingTop: props.theme.spacing(1),
}));

export const StyledTabs = styled(Tabs)(() => ({
  top: 0,
  backgroundColor:"#fff",
  '& .MuiTabs-scroller': {
    overflow: "auto hidden!important",
    scrollbarWidth: 'none' as 'none',
  }
}));